<template>
    <div class="content-manage">
        <hint-real-name @getResult="getResult"></hint-real-name>
        <ul class="task-list" v-if="taskList.length">
            <li class="task-item" v-for="(item,index) in taskList" :key="index">
                <div class="task-info">
                    <img class="task-pic" :src="item.gameLogo" width="48" height="48" alt="">
                    <div>
                        <p class="task-title f-hide-col-2">
                            {{item.title}}
                        </p>
                        <div>
                            <span class="task-price">{{Number(item.cpa).toFixed(2)}}</span>元
                            <span class="task-tag">CPA</span>
                        </div>
                    </div>
                </div>
                <div class="task-footer">
                    <div>
                        <i class="ico ico-time"></i>
                        {{item.startTime}} ~ {{item.endTime}}
                    </div>
                    <div>
                        <a href="javascript:;" class="join-btn" @click="toJoin(item.id)">参加</a>
                    </div>
                </div>
            </li>
        </ul>
        <div class="data-null" v-else style="margin-top: 10px;">
            <img src="~Assets/img/pages/v4/search-null.png" alt="">
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/admire/index.scss';
.task-list {
    padding: 10px 5px;
    display: flex;
    flex-wrap: wrap;
}
.task-item {
    margin: 0 24px 24px 0;
    width: 280px;
    height: 152px;
    border: 1px solid #ebebeb;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    box-sizing: border-box;
    &:nth-of-type(3n) {
        margin-right: 0;
    }
    .task-info {
        display: flex;
        margin-bottom: 20px;
    }
    .task-pic {
        margin-right: 12px;
        border-radius: 5px;
    }
    .task-title {
        color: #666;
        font-size: 14px;
        height: 42px;
    }
    .task-price {
        font-size: 20px;
    }
    .task-tag {
        display: inline-block;
        line-height: 20px;
        padding: 0 5px;
        text-align: center;
        font-size: 14px;
        background: #fff2e8;
        color: #fd7e28;
    }
    .task-footer {
        display: flex;
        justify-content: space-between;
        color: #666;
        font-size: 14px;
    }
    .ico-time {
        vertical-align: -2px;
        margin-right: 3px;
    }
    .join-btn {
        display: inline-block;
        background: #fd7e28;
        padding: 0 10px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #fff;
        border-radius: 2px;
    }
}
</style>
<script>
import {
    DownloadTaskList
} from 'Services/getData.js';
import hintRealName from 'Components/v4/hint/real_name.vue';
export default {
    data() {
        return {
            taskList: []
        };
    },
    mounted() {
        // this.getList()
    },
    components: {
        hintRealName
    },
    methods: {
        getResult(result) {
            console.log(result);
            if (result) {
                this.getList();
            } else {
                this.$alert('请先完成实名认证和钱包绑定才可参加任务');
            }
        },
        async getList() {
            let res = await DownloadTaskList();
            if (res.status === 200 && res.data.code === 0) {
                this.taskList = res.data.data;
            }
        },
        toJoin(id) {
            this.$router.push({
                name: 'v4-extension-edit',
                query: {
                    id: id
                }
            });
        }
    }
}
</script>
